export const MontserratFont = " 'Montserrat', sans-serif";
export const NunitoFont = " 'Nunito Sans', sans-serif";
